import * as React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Stack,
  Menu,
  Typography,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  MenuItem,
} from '@mui/material';
import logo from '../../assets/images/transcriber-logo.svg';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen'; // Optional: if you want the icon to change
import IconButton from '@mui/material/IconButton';
import { isMobile, isTablet, isBrowser } from 'react-device-detect';

const getInitials = (name = '') => {
  const parts = String(name).trim().split(' ').filter(Boolean);
  if (!parts.length) return 'U';
  const first = parts[0][0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return `${first}${last}`.toUpperCase() || 'U';
};

export default function AppBarHeader(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [headerOpen, setHeaderOpen] = React.useState(false);
  const open = Boolean(anchorEl);
  const userInformation = useSelector(state => state.userDetails.userData);
  const parentHost = localStorage.getItem('parentHost');
  const handleLogoClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  React.useEffect(() => {
    const handler = (e) => {
      const isOpen = !!(e && e.detail && e.detail.open);
      setHeaderOpen(isOpen);
    };
    window.addEventListener('appMenuDrawerState', handler);
    return () => window.removeEventListener('appMenuDrawerState', handler);
  }, []);
  return (
    <AppBar
      className="AppHeader"
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        bgcolor: 'white',
        borderBottom: '1px solid #A6C1D3',
        borderRadius: '0px',

      }}
    >
      <Toolbar
        sx={{
          '&.MuiToolbar-root': {
            justifyContent: 'space-between',
            padding: { xs: '0 16px', md: '0 16px' },
            minHeight: isMobile ? '42px' : '56px',
          },
        }}
      >
        {/* <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            height={36}
          >
            <img src={logo} alt="Logo"
              width={isBrowser ? 100 : 88} />
          </Box>
        </Stack> */}


        <Stack direction="row" alignItems="center" spacing={1.5} gap={'12px'}>
          {(!isMobile && !isTablet) && (
            <IconButton
              onClick={() => window.dispatchEvent(new CustomEvent('toggleAppMenuDrawer'))}
              edge="start"
              sx={{
                color: 'text.primary',
                bgcolor: 'transparent',
                '&:hover': { bgcolor: 'var(--grey-100)' },
              }}
            >

              {headerOpen ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>
          )}

          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            height={36}
          >
            <img src={logo} alt="Logo"
              width={isBrowser ? 100 : 88} />
          </Box>
        </Stack>



        {/* <Box className="use-profile" display={'flex'} alignItems={'center'}>
          <Box
            component="a"
            sx={{
              height: 32,
              display: 'inline-flex',
              alignItems: 'center',
              cursor: 'pointer',
              img: {
                objectFit: 'contain',
              },
            }}
            onClick={handleLogoClick}
          >
            <img
              src={
                userInformation?.company_short_text && parentHost
                  ? `${parentHost}/images/topband_account/company_logo/${userInformation?.company_short_text}`
                  : 'https://mavenvista.com/wp-content/themes/mavenvista/assets/images/logo.png'
              }
              alt="Company Logo"
              
              // width={130}
              // height={36}
               width={isBrowser ? 130 : 58}
              height={isBrowser ? 36 : 36}
            />
          </Box>
        
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            className="User-ProfileMenu"
            slotProps={{
              paper: {
                sx: {
                  mt: 1,
                  width: 300,
                },
              },
            }}
            sx={{
              '& .MuiList-root': {
                p: 0,
              },
              '& .User-ProfileName': {
                borderTop: '3px solid var(--primary-100)',
                backgroundColor: 'var(--grey-50)',
                borderBottom: '1px solid var(--grey-100)',
              },
            }}
          >
            <ListItem className="User-ProfileName">
              <ListItemAvatar>
                <Avatar
                  src={userInformation?.profile_image || userInformation?.avatar_url}
                  sx={{ bgcolor: 'var(--primary-200)' }}
                >
                  {getInitials(userInformation?.username)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={0.5}
                    width="100%"
                    whiteSpace={'nowrap'}
                  >
                    <Typography variant="body2" color="grey.500">
                      User Name :
                    </Typography>
                    <Tooltip title={userInformation?.username}>
                      <Typography variant="body2" color="text.primary" noWrap>
                        {userInformation?.username}
                      </Typography>
                    </Tooltip>
                  </Stack>
                }
                secondary={
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={0.5}
                    width="100%"
                    whiteSpace={'nowrap'}
                  >
                    <Typography variant="body2" color="grey.500">
                      Company Name :
                    </Typography>
                    <Tooltip title={userInformation?.company_name}>
                      <Typography variant="body2" color="text.primary" noWrap>
                        {userInformation?.company_name}
                      </Typography>
                    </Tooltip>
                  </Stack>
                }
              />
            </ListItem>
            <ListItem
              sx={{
                justifyContent: 'center',
                gap: '4px',
                fontSize: '12px',
                color: 'var(--grey-500)',
                '& a': {
                  textDecoration: 'none',
                  color: 'var(--grey-500)',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                },
              }}
            >
              •
              <Link
                href="#"
                underline="hover"
                onClick={() => {
                  props.setTermsConditionFlag(true);
                }}
              >
                Terms and Conditions
              </Link>
            </ListItem>
          </Menu>
        </Box> */}

        {(!isMobile && !isTablet) && (
          <Box className="use-profile" display={'flex'} alignItems={'center'}>
            <Stack
              direction="row"
              alignItems="center"
              gap={1.5}
              onClick={handleLogoClick}
              sx={{
                cursor: 'pointer',
                padding: '6px 12px',
                maxWidth: '200px',
                width: '100%',
                borderRadius: '8px',
                transition: 'background-color 0.2s',
                '&:hover': {
                  bgcolor: 'var(--grey-100)',
                },
              }}
            >
              <Avatar
                src={userInformation?.profile_image || userInformation?.avatar_url}
                sx={{
                  backgroundColor: 'var(--primary-500)', width: 32, height: 32,
                  color: 'white', fontWeight: 600, fontSize: '12px'
                }}
              >
                {getInitials(userInformation?.username)}
              </Avatar>


              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, minWidth: 0 }}>
                <Tooltip title={userInformation?.username}>
                  <Typography
                    variant="subtitle2"
                    color="text.primary"
                    sx={{ fontWeight: 600, lineHeight: 1.2, width: '100%' }}
                    noWrap
                  >
                    {userInformation?.username || 'userInformation '}
                  </Typography>
                </Tooltip>

                <Tooltip title={userInformation?.company_name}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ width: '100%' }}
                    noWrap
                  >
                    {userInformation?.company_name || 'company_name'}
                  </Typography>
                </Tooltip>
              </Box>
              <KeyboardArrowDownIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            </Stack>
            {/* --- MENU DROPDOWN SECTION --- */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              className="User-ProfileMenu"
              slotProps={{
                paper: {
                  sx: {
                    mt: 1.5,
           
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.08)',
                    borderRadius: '12px',
                    padding: 0, // Remove default padding to let items fill space
                    overflow: 'hidden',
                  },
                },
              }}
              sx={{
                '& .MuiMenuItem-root .MuiSvgIcon-root': {
                  marginRight: '0px',
                },
              }}
            >

              {/* 1. Terms and Conditions (Grey Theme) */}
              <MenuItem
                onClick={() => {
                  props.setTermsConditionFlag(true);
                  handleClose();
                }}
                sx={{
                  gap: 1,
                  color: 'text.primary',
                  transition: 'all 0.2s',
                  '& .MuiSvgIcon-root': {
                    color: 'text.primary',
                  },

                  '&:hover': {
                    backgroundColor: 'var(--primary-50)',
                    color: 'var(--primary-500)',

                    '& .MuiSvgIcon-root': {
                      color: 'var(--primary-500)',
                    },
                  },
                }}
              >
                <DescriptionOutlinedIcon sx={{ fontSize: 22 }} />

                <Typography variant="body2">
                  Terms and Conditions
                </Typography>
              </MenuItem>

              {/* Divider Line */}
              {/* <Divider sx={{ my: 0, borderColor: 'grey.300' }} /> */}

              {/* 2. Log Out (Red Theme) */}
              {/* <MenuItem
                onClick={() => {
                  // Logout logic
                  handleClose();
                }}
                sx={{
                  gap: 1,
                  color: 'text.primary',
                  transition: 'all 0.2s',
                  '& .MuiSvgIcon-root': {
                    color: 'text.primary',
                  },

                  '&:hover': {
                    backgroundColor: 'var(--primary-50)',
                    color: 'error.main',

                    '& .MuiSvgIcon-root': {
                      color: 'error.main',
                    },
                  },
                }}
              >
                <LogoutIcon sx={{ fontSize: 22 }} />

                <Typography variant="body2" >
                  Log Out
                </Typography>
              </MenuItem> */}

            </Menu>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
